import Modal from 'react-modal'
import { ConfirmModalModel, AgingModalProps } from '../../models/component'

import './style.css'
import { ACCOUNT_LOCK_MESSAGE, AGING_MESSAGE } from '../../constants'

export const AgingModal: React.VFC<AgingModalProps> = ({
  handleOkButton,
  isOpenModal,
  isAccountLock
}) => {
  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        className="modal-cancel"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(24, 48, 40, 0.9)'
          }
        }}
        ariaHideApp={false}
      >
        <div className="modal-cancel-content">
          <div>
            <div className="modal-cancel-header-text"></div>
            <div className="modal-popup-text">
              {isAccountLock ? ACCOUNT_LOCK_MESSAGE : AGING_MESSAGE}
            </div>
          </div>
          <div className="modal-popup-group-button">
            <button className="confirm-transaction-button" onClick={() => handleOkButton()}>
              รับทราบ
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
